// Import dependencies
import { unsafeCSS, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { getDelaySentence } from '@automator/features/page-template-library/utilities';
import { AutomatorTemplateItem } from '@automator/features/page-template-library/components/template-item/_base';

// Import utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-template-loop-action' )
export class AutomatorTemplateLoopAction extends AutomatorTemplateItem {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * The delay/schedule data of this action
	 *
	 * @type {Object}
	 * @property {Object} delay - Represents the code of the integration.
	 */
	@property( { type: Object, attribute: false } )
	accessor delay;

	/**
	 * The template with the delay/schedule data of this action
	 *
	 * @type {TemplateResult|undefined} The delay/schedule data of this action
	 */
	get _templateDelay() {
		if ( isEmpty( this.delay ) ) {
			return;
		}

		return html`
			<div class="item__delay">
				<uo-icon id="clock"></uo-icon>
				${ getDelaySentence( this.delay ) }
			</div>
		`;
	}

	/**
	 * Renders the item sentence
	 *
	 * @return {TemplateResult} The sentence
	 */
	get _templateSentence() {
		return html`
			<div class="item__sentence">
				<uap-template-sentence .sentence="${ this.titleHTML }"></uap-template-sentence>
				${ this._templateDelay }
			</div>
		`;
	}
}
